import actions from './actions';
import { getItem, setItem, removeItem } from '../../utility/localStorageControl';

const { SET_SUCURSAL, SET_SUCURSALES_LIST, SET_LOADING, SET_ERROR } = actions;

const initState = {
  current: getItem('sucursal') || null,
  list: [],
  loading: false,
  error: null,
};

const sucursalReducer = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_SUCURSAL:
      // Guardar en localStorage cuando se selecciona una sucursal
      if (payload) {
        setItem('sucursal', payload);
      } else {
        removeItem('sucursal');
      }
      return {
        ...state,
        current: payload,
        error: null,
      };

    case SET_SUCURSALES_LIST:
      return {
        ...state,
        list: payload,
        error: null,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default sucursalReducer;
